// Strangle IV / HV60 and put-call skew (backend: Scanner/StrangleVolatility.cs).

// Backtest: long strangles lost money when the IV paid was above 1.4x the trailing 60-day realized vol.
export const STRANGLE_IV_HV_MAX = 1.4;
// Put IV minus call IV of the same strangle, in vol points.
export const PUT_CALL_SKEW_MAX = 6;

// i18n key of the tooltip on a "—": why the value is null. Rows without a reason are from scans other than Sweet
// Spot, whose rows never carry these fields (or Sweet Spot rows written before the feature).
export function nullReasonKey(reason) {
  return reason ? `strangle-null-${reason}` : "strangle-null-not-scored";
}
